import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getActiveAbsenceTypes = (
    token: string,
    backend: string
) => {
    return fetch(
        `${getApiUrl(backend)}get_all_active_absence`,
        {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
};

export default getActiveAbsenceTypes;